import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgFailed = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M7.997 15q1.436 0 2.702-.549a7.156 7.156 0 0 0 3.752-3.747A6.7 6.7 0 0 0 15 8q0-1.437-.549-2.704a7.1 7.1 0 0 0-1.517-2.23A7.2 7.2 0 0 0 10.7 1.55 6.7 6.7 0 0 0 7.99 1q-1.434 0-2.702.549A7.17 7.17 0 0 0 1.55 5.296 6.7 6.7 0 0 0 1 8q0 1.437.549 2.704.548 1.267 1.51 2.236a7.1 7.1 0 0 0 2.235 1.511A6.7 6.7 0 0 0 7.997 15m-2.222-4.134a.63.63 0 0 1-.454-.183.63.63 0 0 1-.183-.454q0-.264.19-.447l1.768-1.775-1.768-1.762a.63.63 0 0 1-.19-.447q0-.279.183-.454a.63.63 0 0 1 .454-.183q.264 0 .454.176l1.774 1.769 1.782-1.77a.62.62 0 0 1 .454-.189q.264 0 .446.19.19.182.19.447a.63.63 0 0 1-.19.454L8.912 8.007l1.768 1.768q.19.177.19.454a.62.62 0 0 1-.19.454.62.62 0 0 1-.454.183.62.62 0 0 1-.46-.183L8.002 8.915 6.25 10.683a.67.67 0 0 1-.474.183"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFailed);
export default ForwardRef;
